// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.calendarAssingment-absence-card .absence-label {
  width: 120px;
  flex-shrink: 0;
}

/* Контейнер для инпутов и дропдаунов */
.calendarAssingment-absence-card .input-container {
  width: calc(100% - 120px - 12px);
  max-width: 100%;
}

/* Стили для Dropdown */
.calendarAssingment-absence-card .absence-type-dropdown {
  width: 100% !important;
  max-width: 100%;
}

.calendarAssingment-absence-card .absence-type-dropdown .p-dropdown-label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
  box-sizing: border-box;
}

.assignmentsAbsenceCard-dropdown--panel .p-dropdown-item {
  word-break: break-all;
  white-space: normal;
}
`, "",{"version":3,"sources":["webpack://./src/ui/css/AssignmentsAbsenceCard.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA,uCAAuC;AACvC;EACE,gCAAgC;EAChC,eAAe;AACjB;;AAEA,uBAAuB;AACvB;EACE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB","sourcesContent":[".calendarAssingment-absence-card .absence-label {\n  width: 120px;\n  flex-shrink: 0;\n}\n\n/* Контейнер для инпутов и дропдаунов */\n.calendarAssingment-absence-card .input-container {\n  width: calc(100% - 120px - 12px);\n  max-width: 100%;\n}\n\n/* Стили для Dropdown */\n.calendarAssingment-absence-card .absence-type-dropdown {\n  width: 100% !important;\n  max-width: 100%;\n}\n\n.calendarAssingment-absence-card .absence-type-dropdown .p-dropdown-label {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.assignmentsAbsenceCard-dropdown--panel .p-dropdown-item {\n  word-break: break-all;\n  white-space: normal;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
